import { render } from "./DrPatientConnection.vue?vue&type=template&id=5dc89bb1&scoped=true&ts=true"
import script from "./DrPatientConnection.vue?vue&type=script&lang=ts"
export * from "./DrPatientConnection.vue?vue&type=script&lang=ts"

import "./DrPatientConnection.vue?vue&type=style&index=0&id=5dc89bb1&lang=sass&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc89bb1"]])

export default __exports__